// extracted by mini-css-extract-plugin
export var container = "_9d-0";
export var error = "_9d-9";
export var label = "_9d-5";
export var light = "_9d-6";
export var md = "_9d-3";
export var sm = "_9d-2";
export var thin = "_9d-8";
export var thinBold = "_9d-7";
export var vertical = "_9d-4";
export var xs = "_9d-1";